<div class="content">
    <h1>Privacy Policy</h1>
    <em>Effective Date: 7/28/2025</em>
    
    <p>Your privacy is important to us. This Privacy Policy explains what information we collect, how we use it, and your
        rights regarding your data.</p>
    
    <h2>1. Who We Are</h2>
    <p>WondrVoices is part of the Wondrlink Foundation (EIN: 33-4493221), a nonprofit organization that supports cancer
        patients through programs like WondrVoices.</p>
    
    <h2>2. What Information We Collect</h2>
    <p><strong>Optional Personal Information:</strong> If you choose to provide it, we collect your name and email address,
        as well as an optional credit name (e.g., to honor someone or recognize the creator).</p>
    <p><strong>Uploaded Content:</strong> The image, drawing, photo, note, or artwork you submit.</p>
    <p><strong>Location (Optional):</strong> We may collect your approximate location at the time of upload to understand
        where contributions come from.</p>
    
    <h2>3. How We Use This Information</h2>
    <ul>
        <li>To manage and moderate submissions.</li>
        <li>To display approved cards on our website.</li>
        <li>To track and understand regional participation.</li>
        <li>To potentially provide credit or attribution (if explicitly authorized).</li>
        <li>To communicate with you if needed regarding your submission.</li>
    </ul>
    <p>We will never sell your data or use it for targeted advertising.</p>
    
    <h2>4. Content Rights</h2>
    <p>By submitting content through the app, you grant Wondrlink Foundation a non-exclusive, royalty-free license to use
        the content to support its nonprofit mission. This includes sharing with patients, publishing on our website, or
        printing for fundraising or emotional support campaigns.</p>
    <p>We reserve the right to approve or reject submissions based on content relevance, image quality, and overall
        alignment with our mission. Submissions that are blurry, poorly lit, or contain inappropriate, insensitive, or
        off-topic material will not be shown publicly or printed.</p>
    
    <h2>5. Data Retention and Deletion</h2>
    <p>We retain your submissions indefinitely for mission-related purposes unless you request deletion.</p>
    <p>If requested, and we can verify your identity and submission, we will delete the digital copy.</p>
    <p>We cannot recall or remove any printed or previously distributed versions.</p>
    
    <h2>6. Your Rights</h2>
    <p>You may contact us at any time to:</p>
    <ul>
        <li>Request access to or deletion of your submission.</li>
        <li>Withdraw consent for any future public attribution.</li>
        <li>Ask questions or raise concerns.</li>
    </ul>
    <p>Email: contact&#64;wondrlink.org</p>
    
    <h2>7. Data Security</h2>
    <p>We take reasonable measures to secure submitted data. However, no transmission over the internet is 100% secure.</p>
    
    <h2>8. Changes to This Policy</h2>
    <p>We may update this policy from time to time. Significant changes will be posted in the app and on our website.</p>
    
    <p>Thank you for being part of WondrVoices. Your contributions help create comfort and hope for patients facing the
        hardest days of their lives.</p>
</div>